<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-map-marker"
    ></vuse-section-definition>

    <v-row class="fill-width">
      <v-col cols="8" sm="8">
        <v-row class="mx-3">
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                background-color="#EDF2F7"
                filled
                v-model="search.email"
                label="Email"
                placeholder="Nhập Email"
                @keyup="debounceInput"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" sm="4" align="right">
        <v-btn color="primary" align="right" @click="openDialog">
          Thêm
        </v-btn>
      </v-col>
    </v-row>


    <v-container fluid class="content_product1 rounded-lg">

      <v-row justify="center" align="center">
        <!-- <v-col cols="12" align="right">
          <v-btn
              class="mr-16"
              color="primary"
              align="right"
              @click="openDialog"
          >
            Thêm
          </v-btn>
        </v-col> -->
        <v-col cols="12" >
          <v-data-table
              :headers="headers"
              :items="dataResult"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-center">
          {{ !is_edit ? 'Thêm mới' : 'Cập nhật'}} người dùng
        </v-card-title>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Tài khoản"
                  v-model="user_name"
                  placeholder="Tài khoản"
                  :disabled="is_edit ? true : false"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Email"
                  v-model="email"
                  placeholder="Nhập email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  :type="show ? 'text' : 'password'"
                  background-color="#EDF2F7"
                  filled
                  :label="is_edit ? 'Mật khẩu mới' : 'Mật khẩu'"
                  v-model="password"
                  :placeholder="is_edit ? 'Mật khẩu mới' : 'Mật khẩu'"
                  @click:append="show = !show"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                      @click="dialog = false"
                  >
                    Hủy
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn v-if="is_edit"
                      color="primary"
                      @click="update"
                  >
                    Lưu
                  </v-btn>
                  <v-btn
                      v-else
                      color="primary"
                      @click="addNew"
                  >
                    Lưu
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {SAVE_USER, GET_DETAIL_USER, SET_DETAIL_USER, UPDATE_DATA_USER, DELETE_USER, GET_DATA_SEARCH_USER} from '@/store/modules/user';
import {mapGetters} from 'vuex';
import {debounce} from "debounce";
export default {
  data() {
    return {
      show: false,
      email:'',
      user_name: '',
      password: null,
      dialog:false,
      page_number: 1,
      page: "Quản lý người dùng",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý người dùng",
          disabled: true,
        },
      ],
      headers: [
        { text: 'ID', value: 'id', align: 'start', },
        { text: 'Tài Khoản', value: 'user_name' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'actions' },
      ],
      search: {
        email: "",
        limit: 10,
      },
      is_edit:false,
    };
  },
  computed:{
    ...mapGetters({
      user: 'user',
      dataResult: "dataSearchUser",
    })
  },
  watch:{
    user(val){
      if (val && val.id) {
        this.email = val.email;
        this.user_name = val.user_name;
      }
    }
  },
  async created() {
    this.search.email = this.$route.query.email || ''
    this.params();
    await this.$store.dispatch(`${GET_DATA_SEARCH_USER}`);
  },

  methods:{
    async editItem(id){
      await this.$store.dispatch(`${GET_DETAIL_USER}`, id)
      this.dialog = true;
      this.is_edit = true;
    },
    deleteItem(id){
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_USER}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_DATA_SEARCH_USER);
        }
      })
    },
    async addNew() {
      const _this = this;
      let data = {
        user_name: this.user_name,
        email: this.email,
        password: this.password
      }
      await this.$store.dispatch(`${SAVE_USER}`,data).then((data)=>{
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_DATA_SEARCH_USER}`);
          _this.dialog = false;
        }else{
          alert(data.data.errors)
        }
      })
    },
    async update() {
      const _this = this;
      let data = {
        id: this.user.id,
        user_name: this.user_name,
        password: this.password,
        email: this.email
      }
      await this.$store.dispatch(`${UPDATE_DATA_USER}`,data).then((data)=>{
        if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
                duration:1000,
                position:'top-center'
            })
            _this.$store.dispatch(GET_DATA_SEARCH_USER, {});
            _this.dialog = false;
            _this.resetData();
        }else{
          alert(data.data.errors)
        }
      });
        this.dialog = false;
    },
    async openDialog(){
      this.resetData();
      this.dialog = true;
      this.is_edit = false;
      await this.$store.commit(`${SET_DETAIL_USER}`, {})
    },

    resetData(){
      this.user_name = '';
      this.email = '';
      this.password = '';
    },
    
    replaceUser() {
      this.$router.replace({
        query: {
          email: this.user.email,
          page_current: parseInt(this.page_number),
        }
      })
    },
    params() {
      let param = {
        email: this.search.email,
      };
      this.$store.dispatch(GET_DATA_SEARCH_USER, param);
    },
    debounceInput: debounce(function (e) {
      this.search.email = e.target.value;
      this.params();
      this.replaceUser();
    }, 200),
  }
};
</script>
<style lang="scss">
.content_product1 {
  background: #ffffff !important;

}
</style>
